/** Only allow http(s) hrefs from server-supplied Evidence URLs. */
export const safeHttpHref = (url: string | undefined): string | undefined => {
  const trimmed = url?.trim();
  if (!trimmed) return undefined;
  try {
    const protocol = new URL(trimmed).protocol;
    return protocol === 'https:' || protocol === 'http:' ? trimmed : undefined;
  } catch {
    return undefined;
  }
};

/**
 * Split spoken / mid-tool Evidence text into display lines.
 * Strips leading `-` / `•` / `*` so bullet chrome can own the markers.
 * Also breaks inline numbered runs (`1. … 2. …`) when the wire text lacks newlines.
 */
export function splitEvidenceKeypointLines(text: string): string[] {
  const withBreaks = text
    // "1. foo 2. bar" / "• foo 2. bar" → newline before each numbered item after the first.
    .replace(/(?!^)\s+(\d+)\.\s+/g, '\n$1. ');
  return withBreaks
    .split(/\n+/)
    .map((line) =>
      line
        .replace(/^[-•*]\s+/, '')
        .replace(/^\d+\.\s+/, '')
        // Wire often wraps labels in `**…**` without a markdown renderer on this path.
        .replace(/\*\*/g, '')
        .trim()
    )
    .filter(Boolean);
}
